<template>
  <div class="card h-100">
    <img
      v-if="showImage && !isMobile()"
      class="card-img-top img-fluid"
      :src="image"
      alt="Card image cap"
      loading="lazy"
    />
    <div class="card-body">
      <h5 class="card-title">{{ data.title }}</h5>
      <p class="card-text">{{ truncate(data.selftext, 100, true) }}</p>
      <a
        :href="'https://www.reddit.com' + data.permalink"
        target="_blank"
        class="btn btn-primary"
        >Read more on Reddit 🔗</a
      >
      <hr />
      <span class="badge bg-secondary">Subreddit: {{ data.subreddit }}</span>
      <br />
      <span class="badge bg-dark">Score: {{ data.score }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: Object,
  },
  data() {
    return {
      showImage: false,
      image: "",
    };
  },
  mounted() {
    if (this.data.preview) {
      this.showImage = true;
      this.image = this.data.preview.images[0].source.url.replaceAll(
        "amp;",
        ""
      );
    } else {
      this.image = "";
    }
  },
  methods: {
    truncate(str, n, useWordBoundary) {
      if (str.length <= n) {
        return str;
      }
      const subString = str.substr(0, n - 1); // the original check
      return (
        (useWordBoundary
          ? subString.substr(0, subString.lastIndexOf(" "))
          : subString) + "..."
      );
    },
    isMobile() {
      if (screen.width <= 760) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>

<style scoped>
.btn-primary {
  background-color: #ff5700;
  border-color: #ff5700;
}

.card-img-top {
  width: 100%;
  height: 15vw;
  object-fit: cover;
}
</style>